import React, { useContext } from 'react'
import "./style.scss"
import { UserContext } from '../../../utils/context/userContext'
import { HeightCalculate } from "../../../utils/helpers"
import { Images } from '../../../utils/Images'
import Icon from 'react-icons-kit'
import { checkCircle, heart, xCircle } from 'react-icons-kit/feather'

const Index = ({ data }) => {
    const { user } = useContext(UserContext)

    const partner = data?.partner || {}
    const count = Number(partner?.count) || 0
    const score = Math.round((count / 7) * 100)

    const theirImage = data?.images?.[0]?.name || Images.NoImage
    const ownImage = user?.profilePicture?.clearImage
        ? `${user.profilePicture.clearImage}`
        : Images.NoImage

    const ageRange = partner?.ageRange || {}
    const heightRange = partner?.heightRange || {}

    const ageText = (ageRange?.startFrom || ageRange?.endTo)
        ? `${ageRange?.startFrom || '---'} - ${ageRange?.endTo || '---'} years`
        : null

    const heightText = (heightRange?.startFrom || heightRange?.endTo)
        ? `${heightRange?.startFrom ? HeightCalculate(heightRange.startFrom) : '---'} - ${heightRange?.endTo ? HeightCalculate(heightRange.endTo) : '---'}`
        : null

    const criteria = [
        { label: 'Age', value: ageText, match: partner?.ageStatus },
        { label: 'Height', value: heightText, match: partner?.heightStatus },
        { label: 'Marital status', value: partner?.material, match: partner?.materialStatus },
        { label: 'Religion / Community', value: partner?.religion, match: partner?.religionStatus },
        { label: 'Mother tongue', value: partner?.motherTongue, match: partner?.motherTongueStatus },
        { label: 'Country living in', value: partner?.country, match: partner?.countryStatus },
        { label: 'Qualification', value: partner?.qualification, match: partner?.qualificationStatus },
    ]

    const lookingFor = data?.gender === 'male' ? 'he' : data?.gender === 'female' ? 'she' : 'he/she'

    return (
        <div className="sp-partner">
            <section className="sp-card">
                <header className="sp-card-head">
                    <span className="sp-card-icon"><Icon icon={heart} size={17} /></span>
                    <div className="sp-card-title">
                        <h5>Partner Preference</h5>
                        <p>What {lookingFor} is looking for, compared with your preference</p>
                    </div>
                    <span className="sp-score-tag">{count} / 7 match</span>
                </header>

                <div className="sp-match">
                    <div className="sp-match-side">
                        <div className="sp-match-avatar">
                            <img src={theirImage} alt={data?.name || 'Member'} />
                        </div>
                        <h6>{data?.name ? data.name.split(' ')[0] : 'Member'}</h6>
                        <p>{data?.gender === 'male' ? 'His' : data?.gender === 'female' ? 'Her' : 'Their'} preference</p>
                    </div>

                    <div className="sp-match-score">
                        <div className="sp-ring" style={{ '--pct': `${score}%` }}>
                            <span>{count}<small>/7</small></span>
                        </div>
                        <p>2-way match</p>
                    </div>

                    <div className="sp-match-side">
                        <div className="sp-match-avatar">
                            <img src={ownImage} alt="You" />
                        </div>
                        <h6>You</h6>
                        <p>Your preference</p>
                    </div>
                </div>

                <ul className="sp-criteria">
                    {criteria.map((row, i) =>
                        <li key={i} className={row.match ? 'is-match' : ''}>
                            <span className="sp-criteria-icon">
                                <Icon icon={row.match ? checkCircle : xCircle} size={17} />
                            </span>
                            <div className="sp-criteria-text">
                                <p className="k">{row.label}</p>
                                <p className={`v ${!row.value ? 'is-empty' : ''}`}>
                                    {row.value || 'Not specified'}
                                </p>
                            </div>
                            <span className="sp-criteria-state">
                                {row.match ? 'Match' : 'No match'}
                            </span>
                        </li>
                    )}
                </ul>
            </section>
        </div>
    )
}

export default Index
